module.exports = __webpack_public_path__ + "img/27359cc.png";